import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import { PATH_TO_SCHOOL_INFO_STATE } from "../consts";
import SchoolInfoState from "../models/SchoolInfoState";
import * as stateSelectors from "./state";

export function getSchoolInfoSliceFromStore(state: any): SchoolInfoState {
  return state.get(PATH_TO_SCHOOL_INFO_STATE);
}

export const {
  hasSchool: userHasSchool,
  getSchoolId: getUserSchoolId,
  getSchoolName: getUserSchoolName,
  getSchoolLocalAuthority: getUserSchoolLocalAuthority,
  getSchoolTown: getUserSchoolTown,
  isSchoolInternational: isUserSchoolInternational,
  getSchoolMat: getUserSchoolMat,
  getSchoolUrn: getUserSchoolUrn,
  isSchoolPrivate,
  schoolInfoIsFetching,
  schoolInfoFetchSucceeded,
  schoolInfoFetchErrored,
  schoolInfoFetchFinished,
  schoolInfoNeedsFetching
} = composeSelectors(getSchoolInfoSliceFromStore, stateSelectors);
